module.exports = __webpack_public_path__ + "img/fruit-cherries-190x100.0c7901f5.jpg";